import { render, staticRenderFns } from "./DistributorGroups.vue?vue&type=template&id=28fc7007&"
import script from "./DistributorGroups.vue?vue&type=script&lang=js&"
export * from "./DistributorGroups.vue?vue&type=script&lang=js&"
import style0 from "./DistributorGroups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports